<template>
  <v-app>
    <router-view />
    <v-overlay
      :value="$store.getters.isLoadingActive"
      z-index="900">
      <div class="text-center">
        <div
          id="global-loading-msg"
          class="mb-6">
          {{$store.state.loadingMessage}}
        </div>
        <v-progress-circular
          indeterminate
          size="64">
        </v-progress-circular>
      </div>
    </v-overlay>

    <!-- Warning Dialog -->
    <WarningDialog />
    <!-- / Warning Dialog -->

    <!-- Confirm Dialog -->
    <ConfirmDialog />
    <!-- / Confirm Dialog -->

    <!-- User Update Password Modal Form -->
    <UserUpdatePasswordModalForm />
    <!-- / User Update Password Modal Form -->

    <!-- Customer Modal Form -->
    <CustomerModalForm />
    <!-- / Customer Modal Form -->

    <!-- Employee Modal Form -->
    <EmployeeModalForm />
    <!-- / Employee Modal Form -->

    <!-- Computer Modal Form -->
    <ComputerModalForm />
    <!-- / Computer Modal Form -->

    <!-- Support Contract Modal Form -->
    <SupportContractModalForm />
    <!-- / Support Contract Modal Form -->

    <!-- Code Modal Form -->
    <CodeModalForm />
    <!-- / Code Modal Form -->
  </v-app>
</template>

<script>
import UserUpdatePasswordModalForm from './components/UserUpdatePasswordModalForm.vue';
import CustomerModalForm from './components/CustomerModalForm.vue';
import EmployeeModalForm from './components/EmployeeModalForm.vue';
import ComputerModalForm from './components/ComputerModalForm.vue';
import SupportContractModalForm from './components/SupportContractModalForm.vue';
import CodeModalForm from './components/CodeModalForm.vue';
import { browserStorage } from './browser-storage';

export default {
  name: 'App',
  components: {
    UserUpdatePasswordModalForm,
    CustomerModalForm,
    EmployeeModalForm,
    ComputerModalForm,
    SupportContractModalForm,
    CodeModalForm,
  },
  created() {
    // set theme
    const dark = browserStorage.localStorageGet('darkMode', false);
    this.$vuetify.theme.dark = dark;

    // handle errors
    this.$http.interceptors.response.use(undefined, (err) => new Promise(() => {
      const { response } = err;
      let msg = '';
      let title = '';

      if (response
        && response.data
        && response.data.Error) {
        msg = response.data.Error;
        title = 'Error';

        if (response.status === 401) {
          msg = 'Your previous session has expired. Please sign in again.';
          title = 'Please sign in again';
          this.$store.commit('signOut');
          this.$store.commit('authError', this.$route);
          this.$router.push({ name: 'SignInPage' });
        }

        this.showWarning(msg, title);
      }

      throw response;
    }));

    this.$store.dispatch(
      'initialize',
      {
        tokenSignIn: true,
      },
    ).then(() => {
      if (this.$store.getters.isLoggedIn
          && this.$route.name === 'SignInPage') {
        this.$router.push({ name: 'CallLogPage' });
      }
    });
  },
};
</script>

<style lang="scss">
#global-loading-msg {
  font-size: 16px;
}
</style>
